import { EventEmitter } from '@angular/core';

export interface PaginationManagerInterface {
  /**
   * Available pages count
   */
  availablePagesCount: number;

  /**
   * Current item list
   */
  currentItemList: Array<any>;

  /**
   * Emitter that emits when offset changes
   */
  offsetChange$: EventEmitter<number>;

  /**
   * Set limits offset
   * @param offset
   */
  setOffset(offset: number): void;
}

/**
 * Default limits of items per page
 */
export const DEFAULT_LIMIT = 8;

export interface PaginationFilterInterface {
  currency?: string;
  type?: string;
  status?: string;
  offset?: number;
}

export class PaginationManager implements PaginationManagerInterface {
  /**
   * Current limit of items per page
   */
  private readonly _limit: number;

  /**
   * List of all items
   */
  private _itemList: Array<any> = [];

  /**
   * Item list for current offset
   */
  private _currentItemList: Array<any> = [];

  /**
   * Current offset
   */
  private _offset: number;

  /**
   * Offset change event emitter
   */
  private _offsetChange$: EventEmitter<number> = new EventEmitter();

  private _totalCount: number;

  constructor(limit: number = DEFAULT_LIMIT) {
    this._limit = limit;
  }

  /**
   * Returns count of available pages
   */
  get availablePagesCount(): number {
    return Math.ceil((this._totalCount ? this._totalCount : this._itemList.length) / this._limit);
  }

  /**
   * Returns list of active items
   */
  get currentItemList(): Array<any> {
    return this._currentItemList;
  }

  /**
   * Returns offset change emitter
   */
  get offsetChange$(): EventEmitter<number> {
    return this._offsetChange$;
  }

  /**
   * Set item list for pagination
   */
  applyItemList(list: Array<any>, offset = 0) {
    this._itemList = list;
    this.setOffset(offset);
  }

  setItemsCount(totalCount: number): void {
    this._totalCount = totalCount;
  }

  /**
   * Set offset
   *
   * @param offset
   */
  setOffset(offset: number) {
    this._offset = offset;
    this._offsetChange$.next(this._offset);
    this._updateCurrentItemList();
  }

  /**
   * Updates current item list according to current offset
   *
   * @private
   */
  private _updateCurrentItemList() {
    this._currentItemList = this._getItemList(this._offset);
  }

  /**
   * Returns item list by provided offset
   *
   * @param offset
   */
  private _getItemList(offset): Array<any> {
    return this._itemList;
  }
}
